import { useGetFrontTipiDomandaAree } from '@framework/api-client';
import { SelectInput } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import * as React from 'react';
import { useMemo } from 'react';

export interface IInquiryAreaSelectInputProps {
  name: string;
}

export function InquiryAreaSelectInput(props: IInquiryAreaSelectInputProps) {
  const { name } = props;
  const { t } = useTranslation();
  const aooTypesResult = useGetFrontTipiDomandaAree();
  const { data, isLoading, error } = aooTypesResult;

  const options = useMemo(() => {
    return data?.map(area => ({
      label: [area.idArea, area.denominazione].filter(Boolean).join(' - '),
      value: area.idArea!,
    }));
  }, [data]);

  return (
    <SelectInput
      allowClear
      optionFilterProp="label"
      showSearch
      style={{ width: '100%' }}
      loading={isLoading}
      name={name}
      placeholder={t('inquiry.area-filter', 'Amministrazione')}
      options={options}
    />
  );
}
